import React from 'react'

import { FormattedMessage, useIntl } from '@divvy-web/i18n'
import { FormDropdown } from '@divvy-web/skylab.form'
import { Control } from '@divvy-web/skylab.react-hook-form'

import { AddPersonForm } from '@sputnik/schema/creditApplication/addPerson'

interface PersonJobTitleDropdownProps {
  label?: React.ReactNode
  disabled?: boolean
  control: Control<Pick<AddPersonForm, 'title'>>
}

const PersonJobTitleDropdown = ({ control, label, disabled }: PersonJobTitleDropdownProps) => {
  const intl = useIntl()
  const titleOptions = [
    {
      label: intl.formatMessage({
        defaultMessage: 'Chief Executive Officer',
        id: 'sputnik.PersonJobTitleDropdown__xe2d3B',
      }),
      value: 'Chief Executive Officer',
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Chief Financial Officer',
        id: 'sputnik.PersonJobTitleDropdown__3g6tec',
      }),
      value: 'Chief Financial Officer',
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Chief Operating Officer',
        id: 'sputnik.PersonJobTitleDropdown__LvBbJ/',
      }),
      value: 'Chief Operating Officer',
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Managing Member',
        id: 'sputnik.PersonJobTitleDropdown__PY6xGg',
      }),
      value: 'Managing Member',
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'General Partner',
        id: 'sputnik.PersonJobTitleDropdown__WycoFf',
      }),
      value: 'General Partner',
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'President',
        id: 'sputnik.PersonJobTitleDropdown__nD+3eu',
      }),
      value: 'President',
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Vice President',
        id: 'sputnik.PersonJobTitleDropdown__Bih6zH',
      }),
      value: 'Vice President',
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Treasurer',
        id: 'sputnik.PersonJobTitleDropdown__+9snrK',
      }),
      value: 'Treasurer',
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Owner',
        id: 'sputnik.PersonJobTitleDropdown__zINlao',
      }),
      value: 'Owner',
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Executive Director',
        id: 'sputnik.PersonJobTitleDropdown__0ekXzM',
      }),
      value: 'Executive Director',
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Director',
        id: 'sputnik.PersonJobTitleDropdown__hw6g6l',
      }),
      value: 'Director',
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Founder',
        id: 'sputnik.PersonJobTitleDropdown__s+uKG6',
      }),
      value: 'Founder',
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Controller',
        id: 'sputnik.PersonJobTitleDropdown__6PDwDl',
      }),
      value: 'Controller',
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Principal',
        id: 'sputnik.PersonJobTitleDropdown__SRhWkB',
      }),
      value: 'Principal',
    },
  ]
  return (
    <div>
      <FormDropdown
        className='fs-mask'
        control={control}
        disabled={disabled}
        inputProps={{
          name: 'title',
          id: 'title',
          'aria-labelledby': 'title',
        }}
        label={
          label || (
            <span className='fs-unmask'>
              <FormattedMessage
                defaultMessage='Job title'
                id='sputnik.PersonJobTitleDropdown__HsQ3BK'
              />
            </span>
          )
        }
        name='title'
        options={titleOptions}
        placeholder={
          <FormattedMessage
            defaultMessage='Select'
            id='sputnik.PersonJobTitleDropdown__kQAf2d'
          />
        }
      />
    </div>
  )
}

export default PersonJobTitleDropdown
